export const get_route_from_game_code = (game_code) => {
  switch (game_code) {
    case "SK":
      return "/slidekick";
    case "BNG":
      return "/bingo";
    case "LT":
      return "/lightning_trivia";
    case "LTS":
      return "/lightning_trivia_submit";
    case "CC":
      return "/say_what";
    case "TTL":
      return "/two_truths_and_a_lie";
    case "TOTO":
      return "/tip_of_the_tongue_one_round";
    case "TOT":
      return "/tip_of_the_tongue";
    case "WELL":
      return "/wellness";
    case "GAH":
      return "/gifs_against_humanity";
    case "VB":
      return "/verboden";
    case "TW":
      return "/the_word";
    case "FLUS":
      return "/fluster";
    case "DW20":
      return "/done_with_2020";
    case "CT":
      return "/conspiracy_theory";
    case "CHPT":
      return "/charty_party";
      case "OCH":
        return "/ochos_locos";
    default:
      return "slice";
  }
};
